module.exports = __webpack_public_path__ + "img/icn_recurring.6e6079a2.svg";